import Typography from '@/components/atoms/typography/typography';
import { useI18n } from '@/libraries/contexts/i18n-context';
import useCurrencyFormatter from '@/libraries/formatters/use-currency-formatter';
import styles from './booking-price-details-modal-payment-summary.module.scss';

export type BookingPriceDetailsModalPaymentSummaryProps =
  Content.Components['BookingPaymentSummaryDto'];

const BookingPriceDetailsModalPaymentSummary = ({
  amountPaid,
  amountToPay,
  balance,
}: BookingPriceDetailsModalPaymentSummaryProps) => {
  const { t } = useI18n();
  const currencyFormatter = useCurrencyFormatter();

  return (
    <div className={styles.component}>
      <Typography className={styles.headline} tagStyle="bodyMediumBold">
        {t('items.modules.myTripUpcomingPayment.remainingAmount')}
      </Typography>

      <div className={styles.items}>
        <div className={styles.item}>
          <Typography className={styles.label} tagStyle="bodySmall">
            {t('items.modules.myTripUpcomingPayment.amountToPay')}
          </Typography>

          <Typography className={styles.value} tagStyle="bodyLarge">
            {currencyFormatter(amountToPay)}
          </Typography>
        </div>

        <div className={styles.divider} />

        <div className={styles.item}>
          <Typography className={styles.label} tagStyle="bodySmall">
            {t('items.modules.myTripUpcomingPayment.paid')}
          </Typography>

          <Typography className={styles.value} tagStyle="bodyLarge">
            {currencyFormatter(amountPaid)}
          </Typography>
        </div>

        <div className={styles.divider} />

        <div className={styles.item}>
          <Typography className={styles.value} tagStyle="bodySmallBold">
            {t('items.modules.myTripUpcomingPayment.balance')}
          </Typography>

          <Typography className={styles.value} tagStyle="priceMedium">
            {currencyFormatter(balance)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

BookingPriceDetailsModalPaymentSummary.displayName =
  'BookingPriceDetailsModalPaymentSummary';

export default BookingPriceDetailsModalPaymentSummary;
